/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorNoticeDto } from '../../models/vendor-notice-dto';

export interface VendorNoticeControllerDelete$Params {
  id: string;
}

export function vendorNoticeControllerDelete(http: HttpClient, rootUrl: string, params: VendorNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, vendorNoticeControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorNoticeDto>;
    })
  );
}

vendorNoticeControllerDelete.PATH = '/api/vendor-notice/{id}';
